import AclName from '../acl/AclName';
import model from '../models-v2/invoice/description-template';

export default [
  {
    path: '/admin/templates/invoice-descriptions',
    name: 'invoices-description-templates-list',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.SettingsPageTemplatesInvoiceDescriptionsList,
      rule: 'editor',
      search: false,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Opis faktur', url: '/admin/templates/invoice-descriptions' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
